// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2Ud86","name":"ConsentHeader_name__2tg7S","birthday":"ConsentHeader_birthday__38dbc","skeleton":"ConsentHeader_skeleton__3k7Ye"};